import { createContext, useContext, useEffect, useState } from "react";

// Lets a page override the Topbar title/subtitle (e.g. the portal dashboard
// showing "Dashboard" + a live client summary). AppShell falls back to the
// route default when no override is set.
const PageHeaderContext = createContext({ header: null, setHeader: () => {} });

export function PageHeaderProvider({ children }) {
    const [header, setHeader] = useState(null);
    return (
        <PageHeaderContext.Provider value={{ header, setHeader }}>
            {children}
        </PageHeaderContext.Provider>
    );
}

export function usePageHeader() {
    return useContext(PageHeaderContext);
}

// Set the header for the lifetime of a page; clears automatically on unmount.
export function usePageHeaderEffect(header, deps = []) {
    const { setHeader } = usePageHeader();
    useEffect(() => {
        setHeader(header);
        return () => setHeader(null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}
